import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminSidebar from "../admin/AdminSidebar"; 

const colors = {
  brand: "#ffcc00", // Maritime Gold
  bg: "#0a0a0b",    // Deep Void
  panel: "#111114", // Slightly lighter for contrast
  white: "#ffffff",
  text: "#94a3b8"
};

function AdminLayout({ isOpen, setIsOpen }) {
  const location = useLocation();
  const isDispatchPage = location.pathname.includes("/admin/chat");

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const layoutWrapperStyle = {
    display: "flex",
    height: "100vh", 
    width: "100vw",
    background: colors.bg,
    position: "relative",
    overflow: "hidden",
    fontFamily: "'Inter', sans-serif"
  };

  const mainContentStyle = {
    flexGrow: 1,
    marginLeft: isOpen ? "260px" : "0px",
    width: isOpen ? "calc(100% - 260px)" : "100%",
    transition: "margin-left 0.4s cubic-bezier(0.4, 0, 0.2, 1), width 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    padding: isDispatchPage ? "0px" : "40px", 
    boxSizing: "border-box",
    height: "100vh", 
    display: "flex",
    flexDirection: "column",
    backgroundColor: isDispatchPage ? colors.bg : colors.panel,
    overflowX: "hidden", 
    overflowY: "auto",
    borderLeft: isOpen ? "1px solid rgba(255, 204, 0, 0.1)" : "none"
  };

  const masterButtonStyle = {
    position: "fixed",
    top: "25px",
    left: isOpen ? "240px" : "20px",
    zIndex: 999999, 
    width: "35px",
    height: "35px",
    borderRadius: "6px",
    border: "1px solid rgba(255, 204, 0, 0.3)",
    background: colors.bg,
    color: colors.brand,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
    boxShadow: "0 4px 15px rgba(0,0,0,0.5)",
  };

  // Extract active tenant identifier for layout inspection if present
  const adminSession = JSON.parse(localStorage.getItem("adminUser") || "{}");
  const tenantId = adminSession.adminId || localStorage.getItem("adminId");

  return (
    <div style={layoutWrapperStyle} data-tenant-scope={tenantId || "global"}>
      <button 
        onClick={toggleSidebar} 
        style={masterButtonStyle} 
        aria-label="Toggle Navigation"
        onMouseOver={(e) => e.currentTarget.style.background = "rgba(255, 204, 0, 0.1)"}
        onMouseOut={(e) => e.currentTarget.style.background = colors.bg}
      >
        <span style={{ fontSize: '14px', fontWeight: 'bold' }}>➜</span>
      </button>

      <AdminSidebar isOpen={isOpen} />

      <main style={mainContentStyle}>
        <Outlet context={{ isOpen, setIsOpen, toggleSidebar, tenantId }} />
      </main>
    </div>
  );
}

export default AdminLayout;